import Fingerprint2 from "fingerprintjs2";

// get fingerprint id
export const getFingerprint = async (that) => {
  const options = (Fingerprint2.Options = {
    excludes: {
      language: true,
      colorDepth: false,
      deviceMemory: true,
      pixelRatio: true,
      availableScreenResolution: false,
      timezoneOffset: true,
      timezone: true,
      sessionStorage: true,
      localStorage: true,
      indexedDb: true,
      addBehavior: false,
      openDatabase: true,
      cpuClass: true,
      doNotTrack: true,
      plugins: false,
      canvas: true,
      webglVendorAndRenderer: true,
      adBlock: true,
      hasLiedLanguages: false,
      hasLiedResolution: true,
      hasLiedOs: true,
      hasLiedBrowser: true,
      touchSupport: true,
      audio: false,
      enumerateDevices: true,
      hardwareConcurrency: true,
    },
  });
  // store in localStorage and delete after one month
  let fingerprint = JSON.parse(localStorage.getItem("fingerprintId"));
  const oneMonth = 30 * 24 * 60 * 60 * 1000; // one month milliseconds
  if (
    !fingerprint ||
    fingerprint.data === "null" ||
    Date.now() - fingerprint.timestamp > oneMonth
  ) {
    fingerprint = await new Promise((resolve) => {
      Fingerprint2.get(options, (components) => {
        fingerprint = Fingerprint2.x64hash128(
          components.map((component) => component.value).join(""),
          31
        );
        resolve(fingerprint);
      });
    });
  } else {
    fingerprint = fingerprint.data;
  }
  // save fingerprint id to localStorage and store.js
  localStorage.setItem(
    "fingerprintId",
    JSON.stringify({
      data: fingerprint,
      timestamp: Date.now(),
    })
  );
  that.$store.commit("SET_FINGERPRINT", fingerprint);
};

// send user stats track info
export const toBury = (
  that,
  key,
  f1,
  f2,
  f3,
  f4,
  f5,
  platform,
  clubId,
  legal
) => {
  const fingerprint = JSON.parse(localStorage.getItem("fingerprintId"));
  const localLegal = JSON.parse(localStorage.getItem("legal"));
  legal = legal ? legal : localLegal.legal;
  const extern = {
    clubId: clubId || 0,
    legal: legal || 0,
    fingerprintId: (fingerprint && fingerprint.data) || 0,
  };
  // externStr = 'invitedCode,legalcheck,fingerprintId'
  const externStr = `${extern.clubId},${extern.legal},${extern.fingerprintId}`;
  // test env test-logstore
  // that.$axios.get(process.env.VUE_APP_AliBABA, {
  //   params: {
  //     APIVersion: '0.6.0',
  //     __topic__: key,
  //     f1,
  //     f2,
  //     f3,
  //     f4,
  //     f5,
  //     platform,
  //     extern: externStr,
  //     log_type: 10001
  //   }
  // })
  that.$axios.post(process.env.VUE_APP_TRACK_API, [{
    platform: "web",
    data_type: "client_logstore",
    track_data: JSON.stringify({
      topic: key,
      f1,
      f2,
      f3,
      f4,
      f5,
      platform,
      log_type: 10001,
      uid: 0
    }),
    track_time: parseInt(new Date().getTime() / 1000),
  }]);
};

// upload download button track info
export const uploadTrack = (that) => {
  // club_info = {is_invitecode, user_id, platform, club_id}
  const clubInfo = that.$store.state.club_info;
  const buryType = !clubInfo.invitecode
    ? "RegisteredandDownload"
    : "InviteRegisteredandDownload";
  const f3 = !clubInfo.invitecode ? 1 : 2;
  const f4 = clubInfo.userId || 0;
  toBury(
    that,
    buryType,
    801,
    3,
    f3,
    f4,
    0,
    that.$store.state.platform,
    clubInfo.clubId
  );
};
